// TODO: reorg types
import { NucleusPortfolioSummary, TNucleusRoycoPosition } from '@/pages/OptimizerVault/types';
import { camelToSnakeCase, trimSlashes } from '@/utils';
import { ChainId } from '@molecularlabs/nucleus-frontend';

// TODO: make base client
// Reference: https://backend.nucleusearn.io/api/v1/docs/
export class NucleusClient {
  baseUrl: string;
  constructor(domain?: string) {
    if (!domain && !import.meta.env.VITE_NUCLEUS_API_URL)
      console.warn('WARNING, NO DOMAIN SPECIFIED FOR NUCLEUS CLIENT. REQUEST WILL NOT RUN');
    this.baseUrl = (domain ?? import.meta.env.VITE_NUCLEUS_API_URL) + 'v1/';
  }
  async get(endpoint: string, params?: { [k: string]: string | boolean }, useSnakeCase = true) {
    const url = new URL(this.baseUrl + trimSlashes(endpoint));
    try {
      if (params) {
        Object.keys(params).forEach((key) => {
          const formattedKey = useSnakeCase ? camelToSnakeCase(key) : key;
          url.searchParams.append(formattedKey, String(params[key]));
        });
      }
      const res = await fetch(url.toString());
      return res.json();
    } catch (e) {
      console.log(`Error fetching '${url?.toString()}'`);
      console.error(e);
      throw e;
    }
  }

  // Custom functions for every endpoint *appears* heavyweight at first, but it doesn't really add more code/dev time
  // than individiually writing endpoint calls in hooks/queryFns anyway, but has automatic reusability.
  getPortfolio = async (params: { userAddress: string }): Promise<NucleusPortfolioSummary> => {
    const currentPortfolio = await this.get('protocol/current_portfolio', params);
    return currentPortfolio;
  };
  getVaultTvl = async (params: { vaultAddress: string }) => {
    const vaultTvl = await this.get('protocol/tvl', params);
    return vaultTvl;
  };

  getRoycoPortfolio = async (params: { userAddress: string }): Promise<TNucleusRoycoPosition[] | null> => {
    const roycoPortfolio = await this.get('plume/user-portfolio', params);
    return roycoPortfolio;
  };

  getUnderlyingStrategies = async (params: {
    vaultAddress: string;
  }): Promise<{
    [x: ChainId]: {
      [k: string]: {
        valueInBase: number;
        tokenAddress: string;
        decimals: number;
        allocationPercentage: number;
      };
    };
  }> => {
    const underlyingStrategies = await this.get('vaults/underlying_strategies', params);
    return underlyingStrategies;
  };
}

// TODO: right now we typically construct a new client in each file for ease of testing.
// but maybe a spyon will work just fine instead of a full mock, which would make a singleton okay? TBD.
export const nucleusClient = new NucleusClient();
